import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Slide,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useGetBulkUploadDetailsQuery } from "store/slices/apis/bulkUploadSlice";
import TableComponent from "components/grid";
import {ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BulkUploadDetailsDialog = ({ selectedFile, open, onClose }) => {
  const { data, isLoading } = useGetBulkUploadDetailsQuery(selectedFile?.id, {
    skip: !selectedFile?.id,
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          width: "100vw",
          height: "100vh",
          margin: 0,
          borderRadius: 0,
          padding: 0,
        },
      }}
      TransitionComponent={Transition}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>{selectedFile?.fileName || "Bulk Upload"}</span>
        <IconButton edge="end" color="inherit" onClick={onClose}>
           {/* <CloseIcon /> */}
          <CrossIcon style={{ fontSize: "20px", width:"20px", height:"20px", fill:"#808080" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: 3 }}>
        {isLoading ? (
          <Typography
            sx={{
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: 500,
            }}
          >
            Loading...
          </Typography>
        ) : (
          <TableComponent
            columns={[
              { name: "First Name", field: "firstName" },
              { name: "Last Name", field: "lastName" },
              { name: "Email", field: "email" },
              { name: "Phone Number", field: "phoneNumber" },
              { name: "Designation", field: "designation" },
              { name: "Role", field: "role" },
              { name: "Status", field: "status" },
              {
                name: "Error Message",
                field: "errorMessage",
                renderer(params) {
                  return (
                    <>{params?.errorMessage ? params.errorMessage : "N.A."}</>
                  );
                },
              },
            ]}
            data={data || []}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default BulkUploadDetailsDialog;
